module.exports = {
      id: "subscribe-vikatan-usage",
      viewBox: "0 0 365.232 27",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#subscribe-vikatan",
      toString: function () {
        return this.url;
      }
    }